import React from 'react';
import styled from 'styled-components';
import { DraggableComponents } from '../../../../common/types/checkout';
import { sanitizeCustomHtml } from '../../../../common/utils/html-sanitizer.util';

const CustomHtmlWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.5;
  box-sizing: border-box;

  & img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  & iframe,
  & video,
  & embed,
  & object {
    max-width: 100%;
    height: auto;
  }

  & table {
    max-width: 100%;
    overflow-x: auto;
    display: block;
  }

  & pre {
    max-width: 100%;
    overflow-x: auto;
  }
`;

export const CustomHtmlAtom: React.FC<{ component: DraggableComponents }> = ({
  component,
}) => {
  const sanitized = sanitizeCustomHtml(component.content ?? '');

  if (!sanitized.trim()) return null;

  return (
    <CustomHtmlWrapper
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
